module.exports = __webpack_public_path__ + "img/step-2.f480658d.png";